import React, { Component } from 'react';
import styled, { withTheme } from 'styled-components';
import { SimpleLoader, TopNavBar, BottomTabBar, MCList } from '../components';
import { mapCapCoin } from '../utils';

const DeviceWin = styled.div`
  background-color: ${props => props.theme.bg};
  width: 375px;
  height: 667px;
  position: relative;
  display: flex;
  overflow: hidden;
`;

const Flexer = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  width: 100%;
  height: 100%;
  z-index: 1;
`;

const Content = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  width: 100%;
  min-height: 0;
  padding: 2px 0;
  background: ${props => props.theme.fav.bg};
`;

class MarketCap extends Component {
  state = {
    loaded: false,
    coins: null,
  };

  componentDidMount() {
    this.initCoins();
  }

  fetchCoins = async () => {
    const result = [
      {
        id: 'bitcoin',
        name: 'Bitcoin',
        symbol: 'BTC',
        rank: '1',
        price_usd: '5247.12119317',
        price_btc: '1.0',
        '24h_volume_usd': '12529608340.8',
        market_cap_usd: '92614968510.0',
        available_supply: '17650625.0',
        total_supply: '17650625.0',
        max_supply: '21000000.0',
        percent_change_1h: '0.06',
        percent_change_24h: '1.45',
        percent_change_7d: '-1.13',
        last_updated: '1555523070',
      },
      {
        id: 'ethereum',
        name: 'Ethereum',
        symbol: 'ETH',
        rank: '2',
        price_usd: '166.776105698',
        price_btc: '0.03190429',
        '24h_volume_usd': '5595677910.14',
        market_cap_usd: '17628021316.0',
        available_supply: '105698722.0',
        total_supply: '105698722.0',
        max_supply: null,
        percent_change_1h: '0.04',
        percent_change_24h: '0.59',
        percent_change_7d: '-7.16',
        last_updated: '1555523061',
      },
      {
        id: 'ripple',
        name: 'XRP',
        symbol: 'XRP',
        rank: '3',
        price_usd: '0.3341497996',
        price_btc: '0.00006392',
        '24h_volume_usd': '1083427657.28',
        market_cap_usd: '14024517054.0',
        available_supply: '41970748057.0',
        total_supply: '99991649568.0',
        max_supply: '100000000000',
        percent_change_1h: '0.48',
        percent_change_24h: '3.34',
        percent_change_7d: '-6.17',
        last_updated: '1555523044',
      },
      {
        id: 'bitcoin-cash',
        name: 'Bitcoin Cash',
        symbol: 'BCH',
        rank: '4',
        price_usd: '308.532907784',
        price_btc: '0.05902239',
        '24h_volume_usd': '1427722587.62',
        market_cap_usd: '5471406887.0',
        available_supply: '17733625.0',
        total_supply: '17733625.0',
        max_supply: '21000000.0',
        percent_change_1h: '-0.12',
        percent_change_24h: '-2.19',
        percent_change_7d: '1.52',
        last_updated: '1555523045',
      },
      {
        id: 'eos',
        name: 'EOS',
        symbol: 'EOS',
        rank: '5',
        price_usd: '5.4245397755',
        price_btc: '0.00103772',
        '24h_volume_usd': '1891407733.84',
        market_cap_usd: '4915962687.0',
        available_supply: '906245118.0',
        total_supply: '1006245120.0',
        max_supply: null,
        percent_change_1h: '-0.08',
        percent_change_24h: '-0.63',
        percent_change_7d: '-7.36',
        last_updated: '1555523045',
      },
      {
        id: 'litecoin',
        name: 'Litecoin',
        symbol: 'LTC',
        rank: '6',
        price_usd: '79.6078274161',
        price_btc: '0.01522899',
        '24h_volume_usd': '2079926591.64',
        market_cap_usd: '4886460484.0',
        available_supply: '61381659.0',
        total_supply: '61381659.0',
        max_supply: '84000000.0',
        percent_change_1h: '0.22',
        percent_change_24h: '-0.93',
        percent_change_7d: '-10.0',
        last_updated: '1555523046',
      },
      {
        id: 'binance-coin',
        name: 'Binance Coin',
        symbol: 'BNB',
        rank: '7',
        price_usd: '19.5841804503',
        price_btc: '0.00374646',
        '24h_volume_usd': '168132691.89',
        market_cap_usd: '2764806276.0',
        available_supply: '141175490.0',
        total_supply: '189175490.0',
        max_supply: null,
        percent_change_1h: '0.06',
        percent_change_24h: '0.18',
        percent_change_7d: '6.57',
        last_updated: '1555523043',
      },
      {
        id: 'tether',
        name: 'Tether',
        symbol: 'USDT',
        rank: '8',
        price_usd: '1.0065865403',
        price_btc: '0.00019256',
        '24h_volume_usd': '11502762631.1',
        market_cap_usd: '2491818543.0',
        available_supply: '2475513474.0',
        total_supply: '2750057493.0',
        max_supply: null,
        percent_change_1h: '-0.03',
        percent_change_24h: '-0.08',
        percent_change_7d: '-0.08',
        last_updated: '1555523053',
      },
      {
        id: 'stellar',
        name: 'Stellar',
        symbol: 'XLM',
        rank: '9',
        price_usd: '0.1159279584',
        price_btc: '0.00002218',
        '24h_volume_usd': '288608449.73',
        market_cap_usd: '2240715116.0',
        available_supply: '19328513563.0',
        total_supply: '104902369331',
        max_supply: null,
        percent_change_1h: '-0.0',
        percent_change_24h: '0.43',
        percent_change_7d: '-8.4',
        last_updated: '1555523044',
      },
      {
        id: 'cardano',
        name: 'Cardano',
        symbol: 'ADA',
        rank: '10',
        price_usd: '0.0836393707',
        price_btc: '0.00001600',
        '24h_volume_usd': '66308443.0452',
        market_cap_usd: '2168523864.0',
        available_supply: '25927070538.0',
        total_supply: '31112483745.0',
        max_supply: '45000000000.0',
        percent_change_1h: '0.6',
        percent_change_24h: '1.14',
        percent_change_7d: '-6.7',
        last_updated: '1555523044',
      },
      {
        id: 'tron',
        name: 'TRON',
        symbol: 'TRX',
        rank: '11',
        price_usd: '0.0267254069',
        price_btc: '0.00000511',
        '24h_volume_usd': '301833833.362',
        market_cap_usd: '1782105512.0',
        available_supply: '66682072191.0',
        total_supply: '99281283754.0',
        max_supply: null,
        percent_change_1h: '-0.44',
        percent_change_24h: '-0.32',
        percent_change_7d: '-12.09',
        last_updated: '1555523045',
      },
      {
        id: 'monero',
        name: 'Monero',
        symbol: 'XMR',
        rank: '12',
        price_usd: '67.7840617741',
        price_btc: '0.0129671',
        '24h_volume_usd': '99935807.3073',
        market_cap_usd: '1147242265.0',
        available_supply: '16924956.0',
        total_supply: '16924956.0',
        max_supply: null,
        percent_change_1h: '-0.55',
        percent_change_24h: '0.25',
        percent_change_7d: '-4.17',
        last_updated: '1555523041',
      },
      {
        id: 'dash',
        name: 'Dash',
        symbol: 'DASH',
        rank: '13',
        price_usd: '119.893067058',
        price_btc: '0.02293556',
        '24h_volume_usd': '302574806.535',
        market_cap_usd: '1049751864.0',
        available_supply: '8755735.0',
        total_supply: '8755735.0',
        max_supply: '18900000.0',
        percent_change_1h: '0.04',
        percent_change_24h: '0.49',
        percent_change_7d: '-8.6',
        last_updated: '1555523042',
      },
      {
        id: 'bitcoin-sv',
        name: 'Bitcoin SV',
        symbol: 'BSV',
        rank: '14',
        price_usd: '55.9436246275',
        price_btc: '0.01070202',
        '24h_volume_usd': '124125721.839',
        market_cap_usd: '991971984.0',
        available_supply: '17731636.0',
        total_supply: '17731636.0',
        max_supply: '21000000.0',
        percent_change_1h: '-0.26',
        percent_change_24h: '1.76',
        percent_change_7d: '-30.21',
        last_updated: '1555523049',
      },
      {
        id: 'iota',
        name: 'IOTA',
        symbol: 'MIOTA',
        rank: '15',
        price_usd: '0.3106945872',
        price_btc: '0.00005944',
        '24h_volume_usd': '15784795.5676',
        market_cap_usd: '863585014.0',
        available_supply: '2779530283.0',
        total_supply: '2779530283.0',
        max_supply: '2779530283.0',
        percent_change_1h: '0.33',
        percent_change_24h: '0.2',
        percent_change_7d: '-12.05',
        last_updated: '1555523043',
      },
      {
        id: 'tezos',
        name: 'Tezos',
        symbol: 'XTZ',
        rank: '16',
        price_usd: '1.2301849798',
        price_btc: '0.00023533',
        '24h_volume_usd': '6426999.28287',
        market_cap_usd: '814885688.0',
        available_supply: '662409070.0',
        total_supply: '791113980.0',
        max_supply: null,
        percent_change_1h: '0.58',
        percent_change_24h: '8.66',
        percent_change_7d: '23.52',
        last_updated: '1555523043',
      },
      {
        id: 'neo',
        name: 'NEO',
        symbol: 'NEO',
        rank: '17',
        price_usd: '10.9100506177',
        price_btc: '0.00208709',
        '24h_volume_usd': '215996867.37',
        market_cap_usd: '709153290.0',
        available_supply: '65000000.0',
        total_supply: '100000000.0',
        max_supply: '100000000.0',
        percent_change_1h: '0.07',
        percent_change_24h: '-0.07',
        percent_change_7d: '-12.97',
        last_updated: '1555523043',
      },
      {
        id: 'ethereum-classic',
        name: 'Ethereum Classic',
        symbol: 'ETC',
        rank: '18',
        price_usd: '6.2591035841',
        price_btc: '0.00119737',
        '24h_volume_usd': '361019094.611',
        market_cap_usd: '687199156.0',
        available_supply: '109791945.0',
        total_supply: '109791945.0',
        max_supply: '210000000.0',
        percent_change_1h: '0.41',
        percent_change_24h: '0.74',
        percent_change_7d: '-11.47',
        last_updated: '1555523043',
      },
      {
        id: 'ontology',
        name: 'Ontology',
        symbol: 'ONT',
        rank: '19',
        price_usd: '1.3211743787',
        price_btc: '0.00025274',
        '24h_volume_usd': '67831474.2808',
        market_cap_usd: '653788899.0',
        available_supply: '494854358.0',
        total_supply: '1000000000.0',
        max_supply: null,
        percent_change_1h: '0.13',
        percent_change_24h: '1.24',
        percent_change_7d: '-12.62',
        last_updated: '1555523046',
      },
      {
        id: 'maker',
        name: 'Maker',
        symbol: 'MKR',
        rank: '20',
        price_usd: '618.859270513',
        price_btc: '0.11838786',
        '24h_volume_usd': '1216199.7388',
        market_cap_usd: '618859271.0',
        available_supply: '1000000.0',
        total_supply: '1000000.0',
        max_supply: null,
        percent_change_1h: '0.27',
        percent_change_24h: '-3.85',
        percent_change_7d: '-13.6',
        last_updated: '1555523043',
      },
    ];
    return result;
  };

  initCoins = async () => {
    const coinList = await this.fetchCoins();
    const coins = coinList.map(coin => mapCapCoin(coin));
    this.setState({ coins, loaded: true });
  };

  render() {
    const { loaded, coins } = this.state;
    const content = loaded ? <MCList coins={coins} /> : <SimpleLoader />;
    return (
      <DeviceWin>
        <Flexer>
          <TopNavBar title="Coinmend" left="ios-grid-outline" right="ios-add" rightSize="32px" />
          <Content>{content}</Content>
          <BottomTabBar selected="marketcap" />
        </Flexer>
      </DeviceWin>
    );
  }
}

export default withTheme(MarketCap);



// WEBPACK FOOTER //
// ./src/screens/MarketCap.js